

import {Component, Vue, Watch} from "vue-property-decorator";
import {BildirimEntity} from "@/entity/BildirimEntity";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {ProgramPaths} from "@/enum/ProgramPaths";

@Component({
  components: {}
})
export default class BildirimInfo extends Vue {
  bildirimler: Array<BildirimEntity> = [];
  isNotificationsGetOnce = false;
  menuAcik = false;
  bildirimInterval: number | null = null;

  // DEV-3350: zil tazeleme dinleyicisi. $on ve $off aynı fonksiyon referansıyla
  // eşleşmek zorunda; bu yüzden tek ve sabit bir alanda tutuluyor (satır içi bir
  // kapanış verilseydi $off onu eşleştiremez, dinleyici kaldırılamazdı).
  //
  // [dev-3350] inceleme yorumu 881813349 — elle tazeleme "liste bir kez alındı"
  // sayılmıyordu: `isNotificationsGetOnce` yalnız 60 sn'lik interval callback'inde
  // set ediliyordu. Kullanıcı sayfayı yenileyip Excel'e basar ve iş 60 saniyeden
  // kısa sürerse RaporDetayView zili elle tazeliyor; liste yenileniyor ama
  // @Watch('bildirimler') içindeki `if (isNotificationsGetOnce)` kapalı kaldığı için
  // HİÇBİR mesaj çıkmıyor, dosya da kendiliğinden inmiyor (servis yolu inmeyi
  // yapmaz). Elle tazeleme de ilk alım sayılır.
  //
  // Bayrak ok fonksiyonunda değil METOTTA kuruluyor, ölçüldüğü için: alanın ok
  // fonksiyonu olarak çağrıldığında `this` üzerinden yapılan ALAN YAZMASI bileşene
  // yansımıyordu (`isNotificationsGetOnce` false kalıyordu), aynı fonksiyondan
  // çağrılan metot ise `bildirimler`'i güncelliyordu. Yazmayı metot gövdesine
  // almak ikisini de doğru yapıyor.
  bildirimleriTazeledik() {
    this.isNotificationsGetOnce = true;
    this.fetchBildirimler();
  }

  bildirimleriTazele = () => this.bildirimleriTazeledik();

  get okunmamisBildirim() {
    if (this.bildirimler.length > 0)
      return this.bildirimler.filter((item) => (!item.okundu_mu)).length;
    else
      return 0;
  }

  get okunmusBildirim() {
    if (this.bildirimler.length > 0)
      return this.bildirimler.filter((item) => (item.okundu_mu)).length;
    else
      return 0;
  }

  getTakipKart(item: BildirimEntity) {
    // DEV-3350: rapor Excel bildirimi yalnız bir iz; dosya saklama süresi dolunca
    // silinir, bildirim kalır. İndirme Excel Çıktıları sekmesinden yapılır; menü sayfayı
    // örtmesin diye kapanır (close-on-content-click kapalı olduğu için elle).
    if (item.tip === 'rapor_excel') {
      this.menuAcik = false;
      this.okunduYap(item);
      this.$router.push({path: ProgramPaths.ofispro + '/raporlar', query: {sekme: 'excel'}});
      return;
    }

    if (item.takip_durumu === TakipDurumu.acilmamis) {
      this.$router.push(ProgramPaths.icrapro + '/takip-ekle/' + item.takip_id);
    } else {
      this.$router.push(ProgramPaths.icrapro + '/takip/' + item.takip_id);
    }
  }

  // Yalnız okunmamış→okundu (göz butonunun toggle'ından farklı). İstek düşerse yerel
  // durum geri alınır; yönlendirme bundan etkilenmez.
  okunduYap(item: BildirimEntity) {
    if (item.okundu_mu) return;
    item.okundu_mu = true;
    this.$http.put('/api/v1/bildirim/' + item.id, item)
        .then(() => this.fetchBildirimler())
        .catch(() => {
          item.okundu_mu = false;
        });
  }

  // ek_veri.silindi'yi API DEV-3786 ile yazar (saklama süresi dolup iş silinince); o
  // API develop'a girmeden alan hiç gelmez, bildirim normal görünür.
  dosyasiSilindi(item: BildirimEntity): boolean {
    return item.tip === 'rapor_excel' && !!item.ek_veri && item.ek_veri.silindi === true;
  }

  @Watch('bildirimler')
  onBildirimlerChange(yeniBildirimler: Array<BildirimEntity>, eskiBildirimler: Array<BildirimEntity>) {
    if (this.isNotificationsGetOnce) {
      let fark: Array<BildirimEntity> = yeniBildirimler.filter(x => {
        return !eskiBildirimler.some((v) => v.id == x.id)
      });
      fark.reverse().forEach((v: BildirimEntity) => {
        this.$toast.info(v.aciklama);
      })
      let userGuncelle = false;
      fark.forEach((bildirim) => bildirim.baslik == 'İzinler Güncellendi' ? (userGuncelle = true) : null);
      if (userGuncelle)
        this.$http.get("/api/v1/ben").then((response) => {
          this.$store.commit('setUser', response);
        })
    }
  }

  mounted() {
    this.bildirimler = [];
    this.fetchBildirimler();
    this.bildirimInterval = window.setInterval(() => {
      this.isNotificationsGetOnce = true;
      this.fetchBildirimler();
    }, 60000);
    // DEV-3350: rapor Excel hazır olunca RaporDetayView bu olayı yayar; 60 sn'lik
    // yoklamayı beklemeden zil tazelenir ve yeni bildirim görünür.
    this.$root.$on('bildirimleri-tazele', this.bildirimleriTazele);
  }

  beforeDestroy() {
    if (this.bildirimInterval !== null) {
      clearInterval(this.bildirimInterval);
      this.bildirimInterval = null;
    }
    // DEV-3350: dinleyici bırakılır; yoksa her yeniden kurulumda bir kopya daha
    // birikir ve tek olayda birden çok fetch tetiklenir.
    this.$root.$off('bildirimleri-tazele', this.bildirimleriTazele);
  }

  fetchBildirimler() {
    this.$http.get('/api/v1/bildirim').then((response) => {
      this.bildirimler = response.data.reverse();
    });
  }

  tumuOkundu() {
    this.$http.post('/api/v1/bildirim/tumunuOku').then(() => (this.fetchBildirimler()));
  }

  okunanlariTemizle() {
    this.$http.post('/api/v1/bildirim/tumunuOkunduSil').then(() => (this.fetchBildirimler()));
  }

  bildirimiOkuOkuma(bildirim: BildirimEntity) {
    bildirim.okundu_mu = !bildirim.okundu_mu;
    this.$http.put('/api/v1/bildirim/' + bildirim.id, bildirim).then(() => {
      this.fetchBildirimler();
    });
  }
}
